export default __webpack_public_path__ + "static/media/raro-ameaca.f085dd57.webp";